import CommonToast from "../CommonToast";

const UniversalRefreshToast = (titleInfo = "Refreshing balance") => {
  const toastMessage =
    titleInfo === "accountsRefresh"
      ? "Rejecting account."
      : titleInfo === "bulkStatement"
        ? "Uploading statement"
        : titleInfo === "bulkTxnStatement"
          ? "Uploading file"
          : titleInfo === "archive"
            ? "Archiving account."
            : titleInfo === "unarchive"
              ? "Unarchiving account."
              : titleInfo === "approvalaccountsRefresh"
                ? "Approving account."
                : titleInfo === "internalTxn"
                  ? "Rejecting transaction"
                  : titleInfo === "initializeTotp"
                    ? "Initializing TOTP"
                    : titleInfo === "unassignCate"
                      ? "Unassigning categories"
                      : titleInfo === "singleSchedule"
                        ? "Rejecting schedule"
                        : titleInfo === "multiSchedule"
                          ? "Rejecting schedules"
                          : titleInfo;
  return CommonToast({
    text: toastMessage,
    icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
    variant: "var(--processing)",
    buttonNeeded: false,
    btnProps: {
      enabledBgColor: "var(--primary-bg)",
      enabledTextColor: "var(--text-primary)",
      btnText: "",
      handleFunction: () => {},
      icon: "",
      btnType: "button",
      isDisabled: false,
      hoverOption: "white",
    },
  });
};

export default UniversalRefreshToast;
